import { omit, get } from 'lodash';

export default {
  methods: {
    getRouteQuery(key, defaultValue) {
      return get(this.$route, `query.${key}`, defaultValue);
    },
    setRouteQuery(key, value) {
      this.$router.push({ query: { ...this.$route.query, [key]: value } });
    },
    removeRouteQuery(key) {
      this.$router.push({ query: omit(this.$route.query, [key]) });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/route_query.js